/*
 * @Descripttion: 平台规则
 * @version:
 * @Author: min
 * @Date: 2020-10-20 16:22:13
 * @LastEditors  : min
 * @LastEditTime : 2020-11-12 09:42:08
 */
import request from "@/request/request";

/**
 * 平台服务协议
 */
export function getAgreementGetDetailByInstitutionID(params) {
  return request({
    url: "api/Institution/AgreementGetDetailByInstitutionID",
    method: "post",
    data: params
  });
}

// 获取下载信息
export function getInstitutionGelAppDownloadUrl(params) {
  return request({
    url: "api/Site/InstitutionGelAppDownloadUrl",
    method: "post",
    data: params
  });
}

//
export function InstitutionPublicConfig(params) {
  return request({
    url: "api/Institution/InstitutionPublicConfig",
    method: "post",
    data: params
  });
}